import { ModalImageComponent } from "components/external";
import { withTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Image from "next/image";
import { withRouter } from "next/router";
import * as React from "react";
import { trackPage } from "../api";
import { catalogApi, RESTProductItem } from "../api/catalog";
import { transformPrice as transformPriceWithCurrency } from "../api/currency";
import LazyProductImage from "../components/lazy-product-image/lazy-product-image";
import MetaHeader from "../components/meta-header/meta-header";
import SaleProductComponent from "../components/sale-product/sale-product-component";
import { canonical } from "../config";
import FooterTestComponent from "../new-components/footer-test/FooterTest";
import { HeaderTesterComponent } from "../new-components/header-test/HeaderTest";
import nextI18NextConfig from "../next-i18next.config.js";
import styles from "../styles/pages/sale.module.scss";
import {
  DeliveryOfferKey,
  ICacheProducts,
  ISaleTester,
  ShippingPolicyByDeliveryOffer,
} from "../types/sale";
import { formatNextHome, formatPublicHome, transformImage } from "../utils";
import { getLang } from "../utils/lang";

type DeliveryOffer = {
  type: DeliveryOfferKey;
  cost_range: [number, number];
};

class ProductComponent extends React.PureComponent<
  {
    onClick?: (data: any) => void;
    variant?: "simple" | "selection";
    className?: string;
    currency: "usd" | "eur";
    imageWidth?: number;
    hasWebp: boolean;
    position: number;
    locale: "fr" | "en";
    token: string;
    product: RESTProductItem;
    wording: string;
  },
  {}
> {
  public onClick = () => {
    //
  };

  public render() {
    let url =
      "/product/" + this.props.product.product_key + "?v=" + this.props.token;
    if (this.props.product.collapse_key) {
      url +=
        "&collapse_key=" + encodeURIComponent(this.props.product.collapse_key);
    }
    return (
      <a
        className={this.props.className || "col-3 col-sm-6 col-md-6"}
        href={url}
      >
        <SaleProductComponent
          position={this.props.position}
          variant={this.props.variant}
          currency={this.props.currency}
          disableLazy={true}
          wording={this.props.wording}
          onClick={this.onClick}
          locale={this.props.locale}
          name={this.props.product.subtitle}
          product={this.props.product}
          quantity={this.props.product.stock}
          displayBrand={
            this.props.variant === "simple" ||
            this.props.variant === "selection"
          }
          brand_name={this.props.product.title}
          imageWidth={this.props.imageWidth || 265}
          hasWebp={this.props.hasWebp}
        />
      </a>
    );
  }
}

class TesterScreen extends React.Component<
  {
    router: any;
    t: any;
    v: string;
    url: string;
    token: string;
    i18n?: any;
    products?: ICacheProducts;
    sale?: ISaleTester;
  },
  {}
> {
  get getTitle() {
    if (this.props.sale) {
      if (this.props.sale.sale_ended) {
        return `${this.props.sale.name} | ${this.getTrad("sale_ongoing")}`;
      }
      return `${this.props.sale.name} | ${this.getTrad("sale_ongoing")}`;
    }
    return "";
  }

  get renderCashback() {
    if (!this.props.sale.cashback_policy) {
      return;
    }
    return (
      <>
        <div className={styles.sizes} style={{ marginTop: 24 }}>
          <h4>
            <b>{this.props.t("cashback")}</b>
          </h4>
          {this.props.sale.cashback_policy.thresholds.map((c) => {
            return (
              <p key={c.threshold}>
                {transformPriceWithCurrency(
                  c.cashback_amount,
                  this.props.i18n.language,
                  this.props.sale.currency
                )}{" "}
                {this.props.t("cashback_free")}{" "}
                {transformPriceWithCurrency(
                  c.threshold,
                  this.props.i18n.language,
                  this.props.sale.currency
                )}{" "}
                {this.props.t("cashback_purchase")}
              </p>
            );
          })}
        </div>
      </>
    );
  }

  get getDescription() {
    if (this.props.sale) {
      if (this.props.sale.sale_ended) {
        return `${this.getTrad("sale_delivery")}`;
      } else if (this.props.sale.sale_started) {
        return `${this.getTrad("basic")} ${formatPublicHome(
          this.props.sale.end_at,
          getLang(this.props.i18n),
          this.props.sale.store
        )}. ${this.getTrad("sale_delivery")}`;
      }
      return `${this.getTrad("basic")} ${formatNextHome(
        this.props.sale.start_at,
        this.props.sale.end_at,
        getLang(this.props.i18n),
        this.props.sale.store
      )}. ${this.getTrad("sale_delivery")}`;
    }
    return "";
  }

  get getMainImage() {
    if (this.props.sale && this.props.sale.image_header) {
      return transformImage(this.props.sale.image_header, "1200");
      // return `https://img.appchoose.io/unsafe/1200x630/filters:watermark(https://public.choose.app/website/new/images/logo-${
      //   this.props.sale.dark_color ? "white" : "black"
      // }.png,443,272,50)/prod/${
      //   this.props.sale.image_header.split("/prod/")[1]
      // }`;
    }
    return "";
  }

  get getText() {
    if (this.props.sale) {
      if (this.props.sale.sale_ended) {
        return this.getTrad("sale_ended");
      } else if (this.props.sale.sale_started) {
        return `${this.getTrad("sale_ongoing")} ${formatPublicHome(
          this.props.sale.end_at,
          getLang(this.props.i18n),
          this.props.sale.store
        )}`;
      }
      return `${this.getTrad("sale_next")} ${formatNextHome(
        this.props.sale.start_at,
        this.props.sale.end_at,
        getLang(this.props.i18n),
        this.props.sale.store
      )}`;
    }
    return "";
  }

  get getAppleMeta() {
    const path = this.props.router.asPath.replace("/", "").split("?")[0];
    return `chooseapp://${encodeURIComponent(path)}`;
  }

  public state = {
    isLoading: false,
    isInit: false,
    total_items: this.props.products.total_items,
    products: this.props.products.data ?? ([] as RESTProductItem[]),
    displayModal: false,
  };
  public getTrad = (str: string) => {
    return this.props.t(str);
  };

  public componentDidMount() {
    trackPage("Vente", { tester: true });
    this.setState({
      isInit: true,
    });
    if (this.props.sale) {
      try {
        if (typeof window !== "undefined") {
          localStorage.setItem("token", this.props.token);
        }
      } catch (error) {}
      document.title = "Choose X " + this.props.sale.name;
    }
  }

  public getImage = ({ src, width }: any) => {
    return transformImage(src, width + "x");
  };

  public onClickInstagram = () => {
    window.open("https://instagram.com/" + this.props.sale.instagram, "_blank");
  };

  public onClick = () => {
    const path = this.props.router.asPath.split("?")[0];
    this.props.router.push(
      encodeURIComponent(path + "?name=" + this.props.sale.name).replace(
        "tester",
        "testing"
      )
    );
  };

  private renderShippingCost(
    currency: "usd" | "eur",
    costRange: [number, number]
  ) {
    const [first, second] = costRange;
    if (first === second) {
      if (first === 0) {
        return this.renderFreeText();
      }

      return (
        <b>{`${transformPriceWithCurrency(
          first,
          this.props.i18n.language || "fr",
          currency
        )}`}</b>
      );
    } else {
      return (
        <span>
          {this.props.t("shipping.delivery_fee.range.from")}
          <b>
            {transformPriceWithCurrency(
              first,
              this.props.i18n.language || "fr",
              currency
            )}
          </b>
          {this.props.t("shipping.delivery_fee.range.to")}
          <b>
            {transformPriceWithCurrency(
              second,
              this.props.i18n.language || "fr",
              currency
            )}
          </b>
          {this.renderTooltip()}
        </span>
      );
    }
  }

  private renderTooltip() {
    return (
      <div className="tooltip" style={{ marginLeft: 4 }}>
        <img
          style={{ verticalAlign: "middle" }}
          src="https://public.choose.app/website/new/images/ic-information.png"
          srcSet="https://public.choose.app/website/new/images/ic-information@2x.png 2x, https://public.choose.app/website/new/images/ic-information@3x.png 3x"
        />
        <span className="tooltiptext">{this.props.t("shipping.tooltip")}</span>
      </div>
    );
  }

  private renderDeliveryDelay(delayRange: [number, number]) {
    const [first, second] = delayRange;

    if (first === second) {
      return (
        <p>
          {this.props.t("shipping.delay")}
          {this.props.t("shipping.delay.simple", {
            delay: first,
          })}
        </p>
      );
    } else {
      return (
        <p>
          {this.props.t("shipping.delay")}
          {this.props.t("shipping.delay.double", {
            delay: first,
            delay2: second,
          })}
          {this.renderTooltip()}
        </p>
      );
    }
  }

  private getDeliveryOfferLabel(type: DeliveryOfferKey): string {
    switch (type) {
      case "StandardHomeDelivery":
        return this.props.t("shipping.StandardHomeDelivery");
      case "StandardPickupDelivery":
        return this.props.t("shipping.StandardPickupDelivery");
      case "ExpressHomeDelivery":
        return this.props.t("shipping.ExpressHomeDelivery");
      default:
        return type;
    }
  }

  /**
   * Minimum order amount to reach for the delivery offer to be free,
   * `null` when the delivery offer has no franco de port (or is already free).
   */
  private getFreeShippingOverOrderAmount(
    deliveryOffer: DeliveryOffer,
    policiesByDeliveryOffer: ShippingPolicyByDeliveryOffer[]
  ): number | null {
    return (
      policiesByDeliveryOffer.find(
        (policy) => policy.delivery_offer_key === deliveryOffer.type
      )?.free_shipping_over_order_amount ?? null
    );
  }

  /**
   * The minimum order amount shared by every delivery offer, `null` as soon as
   * they differ. When they all share the same one, it is displayed on a single
   * line below the delivery fees instead of on each delivery offer.
   */
  private getCommonFreeShippingOverOrderAmount(
    deliveryOffers: DeliveryOffer[],
    policiesByDeliveryOffer: ShippingPolicyByDeliveryOffer[]
  ): number | null {
    if (deliveryOffers.length < 2) {
      return null;
    }

    const amounts = deliveryOffers.map((deliveryOffer) =>
      this.getFreeShippingOverOrderAmount(
        deliveryOffer,
        policiesByDeliveryOffer
      )
    );
    const [firstAmount] = amounts;

    return firstAmount && amounts.every((amount) => amount === firstAmount)
      ? firstAmount
      : null;
  }

  private renderDeliveryOffers(
    currency: "usd" | "eur",
    deliveryOffers: DeliveryOffer[],
    deliveryOffered: {
      saleStartAt: string;
      deliveryOfferedUntil: string;
    },
    policiesByDeliveryOffer: ShippingPolicyByDeliveryOffer[]
  ) {
    const { saleStartAt, deliveryOfferedUntil } = deliveryOffered;

    const getHeader = (withSeparator: boolean = true) => {
      const hourDiff =
        deliveryOfferedUntil && saleStartAt
          ? Math.abs(
              new Date(deliveryOfferedUntil).getTime() -
                new Date(saleStartAt).getTime()
            ) /
            (1000 * 60 * 60)
          : null;

      if (!hourDiff) {
        return null;
      }

      return (
        <span>
          {withSeparator && " • "}
          {this.renderFreeText()}
          {this.props.t("shipping.offered_until", { hour: hourDiff })}
          <span
            style={{
              color: "#5F6365",
              fontSize: 12,
              fontFamily: "Maison Neue",
              fontStyle: "normal",
              fontWeight: 400,
            }}
          >
            {`(${formatDate(deliveryOfferedUntil, this.props.i18n.language)})`}
          </span>
        </span>
      );
    };

    if (deliveryOffers.length === 1) {
      return (
        <p>
          {this.props.t("shipping.delivery_fee")}
          {this.renderShippingCost(currency, deliveryOffers[0].cost_range)}
          {this.renderFreeShippingOverOrderAmountByDeliveryOffer(
            currency,
            deliveryOffers[0],
            policiesByDeliveryOffer
          )}
          {getHeader(true)}
        </p>
      );
    }

    const commonFreeShippingOverOrderAmount =
      this.getCommonFreeShippingOverOrderAmount(
        deliveryOffers,
        policiesByDeliveryOffer
      );

    return (
      <>
        <p>
          {this.props.t("shipping.delivery_fee")}
          {getHeader(false)}
          <ul style={{ listStyle: "inside", paddingLeft: 8 }}>
            {deliveryOffers.map((offer) => {
              return (
                <p key={offer.type}>
                  <li>
                    {this.getDeliveryOfferLabel(offer.type)}
                    {this.renderShippingCost(currency, offer.cost_range)}
                    {commonFreeShippingOverOrderAmount
                      ? null
                      : this.renderFreeShippingOverOrderAmountByDeliveryOffer(
                          currency,
                          offer,
                          policiesByDeliveryOffer
                        )}
                  </li>
                </p>
              );
            })}
          </ul>
        </p>
        {this.renderCommonFreeShippingOverOrderAmount(
          currency,
          commonFreeShippingOverOrderAmount
        )}
      </>
    );
  }

  private renderFreeText() {
    return (
      <span
        style={{
          color: "#13482B",
          fontFamily: "Maison Neue",
          fontStyle: "normal",
          fontWeight: 600,
        }}
      >
        {this.props.t("shipping.free")}
      </span>
    );
  }

  /**
   * Franco de port displayed inline, on the delivery offer it applies to.
   */
  private renderFreeShippingOverOrderAmountByDeliveryOffer(
    currency: "usd" | "eur",
    deliveryOffer: DeliveryOffer,
    policiesByDeliveryOffer: ShippingPolicyByDeliveryOffer[]
  ) {
    const freeShippingOverOrderAmount = this.getFreeShippingOverOrderAmount(
      deliveryOffer,
      policiesByDeliveryOffer
    );

    if (!freeShippingOverOrderAmount) {
      return null;
    }

    return (
      <span>
        {" — "}
        {this.renderFreeText()}
        {this.props.t("shipping.offered_over_order_amount.by_delivery_offer")}
        <b>
          {transformPriceWithCurrency(
            freeShippingOverOrderAmount,
            this.props.i18n.language || "fr",
            currency
          )}
        </b>
      </span>
    );
  }

  /**
   * Franco de port shared by every delivery offer, displayed on its own line
   * below the delivery fees.
   */
  private renderCommonFreeShippingOverOrderAmount(
    currency: "usd" | "eur",
    freeShippingOverOrderAmount: number | null
  ) {
    if (!freeShippingOverOrderAmount) {
      return null;
    }

    return (
      <p>
        {this.renderFreeText()}
        {this.props.t("shipping.offered_over_order_amount")}
        <b>
          {transformPriceWithCurrency(
            freeShippingOverOrderAmount,
            this.props.i18n.language || "fr",
            currency
          )}
        </b>
      </p>
    );
  }

  public renderDelivery() {
    const { currency, type, start_at } = this.props.sale;
    const {
      delay_range: delayRange,
      delivery_offers,
      delivery_offered_until,
    } = this.props.sale.shipping?.[0];

    if (type === "coupon") {
      return null;
    }

    return (
      <div className={styles.delivery}>
        {this.renderDeliveryOffers(
          currency,
          delivery_offers,
          {
            saleStartAt: start_at,
            deliveryOfferedUntil: delivery_offered_until,
          },
          this.props.sale.shipping_policy?.policies_by_delivery_offer ?? []
        )}
        {this.renderDeliveryDelay(delayRange)}
      </div>
    );
  }

  public renderGiveawayTitle() {
    return (
      <p
        style={{
          color: "#0B1115",
          fontFamily: "Maison Neue",
          fontSize: 14,
          fontWeight: 600,
        }}
      >
        {!this.props.sale.giveaway_policy.over_order_amount
          ? this.props.t("giveaway.title")
          : this.props.t("giveaway.title.over_order_amount", {
              amount: transformPriceWithCurrency(
                this.props.sale.giveaway_policy.over_order_amount,
                this.props.i18n.language,
                this.props.sale.currency
              ),
            })}
      </p>
    );
  }

  public renderGiveaway() {
    if (!this.props.sale.giveaway_policy) {
      return null;
    }
    return (
      <div className={styles.giveaway}>
        <div style={{ gap: 2, display: "flex", flexDirection: "column" }}>
          {this.renderGiveawayTitle()}
          <p>{this.props.sale.giveaway_policy.item.name}</p>
          <p>
            {this.props.t("giveaway.stock")}{" "}
            {this.props.sale.giveaway_policy.item.stock}
          </p>
        </div>
        <img
          src={transformImage(
            this.props.sale.giveaway_policy.item.images[0],
            "80"
          )}
          alt={this.props.sale.giveaway_policy.item.name}
          style={{
            width: 80,
            height: 80,
            borderRadius: 4,
            border: "1px solid #D8D9DA",
            cursor: "zoom-in",
          }}
          onClick={this.onModalClick}
        />
        {!this.state.displayModal ? null : (
          <ModalImageComponent
            images={this.props.sale.giveaway_policy.item.images}
            focusOn={0}
            onClose={this.onModalClick}
          />
        )}
      </div>
    );
  }

  public onModalClick = () => {
    this.setState({ displayModal: !this.state.displayModal });
  };

  public render() {
    return (
      <div className={styles.sale + " " + styles.tester}>
        {this.props.sale ? (
          <MetaHeader
            canonical={canonical + "sales/" + this.props.sale.url}
            keywords={this.props.sale.name}
            pageTitle={this.getTitle}
            description={this.getDescription}
            title={this.getTitle}
            image={this.getMainImage}
            noIndex={true}
          />
        ) : null}

        {this.props.sale ? (
          <HeaderTesterComponent
            link={
              typeof window !== "undefined" && window && window.location
                ? window.location.href
                : "/"
            }
            name={this.props.sale.name}
            onClick={this.onClick}
          />
        ) : null}
        <div className="container align-items-center">
          <div className={`row ${styles.sale_data}`}>
            <Image
              className={`col-7 col-sm-12 col-md-12 ${styles.image}`}
              loader={this.getImage}
              layout="fixed"
              src={
                this.props.sale && this.props.sale.image_header
                  ? this.props.sale.image_header
                  : ""
              }
              alt={`image ${this.props.sale?.name}`}
              width={708}
              height={386}
            />
            <div className="col-sm-0 col-1 col-md-1" />
            <div className={`col-4 col-sm-12 col-md-10 ${styles.sale_info}`}>
              <h1>{this.props.sale?.name}</h1>
              <p className={styles.category}>{this.props.sale?.category}</p>
              {this.props.sale?.badges ? (
                <div className={styles.badges}>
                  {this.props.sale.badges.map((badge) => {
                    return (
                      <div className={styles.badge} key={badge.text}>
                        <LazyProductImage
                          height="16"
                          width="16"
                          disableWebp={true}
                          src={badge.image}
                          alt={badge.text}
                        />
                        <p>{this.props.t(badge.code)}</p>
                      </div>
                    );
                  })}
                </div>
              ) : null}
              <p
                className={styles.date}
                dangerouslySetInnerHTML={{ __html: this.getText }}
              />
              <div
                style={{
                  marginBottom: 24,
                  gap: 8,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {this.renderDelivery()}
                {this.renderGiveaway()}
              </div>
              <p className={styles.description}>
                {this.props.sale?.description}
              </p>
              {this.props.sale?.instagram ? (
                <div
                  className={styles.instagram}
                  onClick={this.onClickInstagram}
                >
                  <img
                    alt="instagram"
                    src={`https://public.choose.app/website/new/images/Instagram.svg`}
                  />
                  <p>
                    {this.props.sale.instagram} (
                    {this.props.sale.instagram_followers})
                  </p>
                </div>
              ) : null}
              {this.renderCashback}
            </div>
          </div>
          {!this.state.isLoading ? (
            <div className="row">
              <div className={`col-sm-0 col-1 col-md-1 ${styles.separation}`} />
              <div className="col-10 col-md-10 col-sm-12">
                <hr className={styles.sale_hr} />
                <h3>
                  {this.state.total_items} article
                  {this.state.total_items > 1 ? "s" : ""}{" "}
                  {this.props.t("on_sale")}
                </h3>
                {this.state.isInit ? (
                  <div className={`${styles.products}`}>
                    {Array.isArray(this.state.products) &&
                    this.state.products.length > 0
                      ? this.state.products.map((product, position) => {
                          return (
                            <ProductComponent
                              hasWebp={false}
                              currency={this.props.sale.currency}
                              locale={this.props.i18n.language || "fr"}
                              token={this.props.token}
                              wording={this.getTrad("from")}
                              variant={
                                this.props.sale.is_selection
                                  ? "selection"
                                  : undefined
                              }
                              product={product}
                              key={position}
                              position={position}
                            />
                          );
                        })
                      : null}
                  </div>
                ) : null}
              </div>
            </div>
          ) : (
            <p>Product creation, in progress...</p>
          )}
        </div>
        <FooterTestComponent url={this.props.sale.url} />
      </div>
    );
  }
}

export const getServerSideProps = async (props) => {
  const tmp = {
    props: {
      ...(await serverSideTranslations(
        props.query.language ||
          props.query.lang ||
          props.locale ||
          props.defaultLocale ||
          "fr",
        ["common", "keys", "sale"],
        nextI18NextConfig as any
      )),
      ...props.query,
      store: props.query.store || "fr",
    },
  } as any;
  try {
    // let sale: ISaleTester = {} as ISaleTester;
    let token = "";
    const v =
      props.query.id && props.query.id.indexOf("@v=") > -1
        ? props.query.id.split("@v=")[1]
        : undefined;
    const id = props.query.id ? props.query.id.split("@v=")[0] : null;
    const sale = await catalogApi.getSaleTester(id, v);
    token = v ?? "";
    if (sale) {
    } else {
      return {
        redirect: {
          destination: "/error?from=tester_sale&id=" + id,
          permanent: false,
        },
      };
    }
    tmp.props.token = token;
    tmp.props.v = v;
    tmp.props.v = v ?? null;
    tmp.props.url = id;
    tmp.props.products = sale.products;
    tmp.props.sale = sale;
    tmp.props.userAgent = props.query ? props.query.ua : {};
  } catch (error) {
    console.log(error);
    tmp.props.error = error;
    tmp.props.sale = {};
    tmp.props.isServerRendered = !!props.req;
    tmp.props.userAgent = props.query ? props.query.ua : {};
  }
  return tmp;
};

export default withTranslation("sale")(withRouter(TesterScreen));

const formatDate = (date: string, lang: any) => {
  try {
    const d = new Date(date);
    return new Intl.DateTimeFormat(lang).format(d);
  } catch (error) {
    return "";
  }
};
